<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'gestoesDeAulas.planosBimestrais' })"
            :id="'btn-voltar-planos'"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Plano Bimestral
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn
          depressed
          color="primary"
          @click="
            () => [
              visualizarPdf(plano.instrutorDisciplinaTurma_id, plano.etapa_id, plano.disciplina.id),
              (dialogPdf = true),
            ]
          "
          :id="'btn-visualizar-pdf'"
        >
          Visualizar Pdf
          <v-icon small right> mdi-note </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="10" md="12" lg="12">
        <v-card>
          <v-card-text>
            <label for="">Professor</label>
            <v-input :id="'input-professor'">
              {{
                plano.gestao_de_aula?.professor ? plano.gestao_de_aula?.professor?.nome : "- - - "
              }}
            </v-input>

            <label for="">Turma</label>
            <v-input :id="'input-turma'">
              {{ plano.gestao_de_aula?.turma ? plano.gestao_de_aula?.turma?.descricao : "- - - " }}
            </v-input>

            <label for="">Disciplina</label>
            <v-input :id="'input-disciplina'">
              {{ plano ? plano.disciplina?.descricao : "- - - " }}
            </v-input>

            <label for="">Data lançamento</label>
            <v-input :id="'input-data-lancamento'">
              <v-chip>
                {{
                  plano ? plano?.created_at?.substr(0, 10).split("-").reverse().join("/") : "- - - "
                }}
              </v-chip>
            </v-input>

            <label for="" :id="'label-ultima-atualizacao'">Ultima atualização</label>
            <v-input :id="'input-ultima-atualizacao'">
              <v-chip>
                {{
                  plano ? plano.updated_at.substr(0, 10).split("-").reverse().join("/") : "- - - "
                }}
              </v-chip>
            </v-input>
            <v-combobox
              v-model="seriesSelecionadas"
              chips
              label="Series"
              multiple
              readonly
              :id="'combobox-series'"
            />
          </v-card-text>
        </v-card>

        <v-card class="mt-5">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <label for="">Status</label>
                <e-situacao-plano-bimestral
                  :plano="plano"
                  v-on:update="listarPlano"
                  :id="'situacao-plano'"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-divider></v-divider>
                <label for="" :id="'label-bimestre'">Período</label>
                <v-input :id="'input-bimestre'">
                  {{ plano.etapa?.descricao ? plano.etapa.descricao : "Sem Descrição" }}
                </v-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="" :id="'label-unidades-tematicas'"
                  >UNIDADES TEMÁTICAS / PRÁTICAS DE LINGUAGEM</label
                >
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.tematica ? plano.tematica : '- - -'"
                  :id="'textarea-unidades-tematicas'"
                ></v-textarea>
              </v-col>
            </v-row>

            <!-- Conteúdo | Assunto | Objetos de conhecimento  -->
            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label :id="'label-objetos-conhecimento'">OBJETOS DO CONHECIMENTO</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.objeto_conhecimento ? plano.objeto_conhecimento : '- - -'"
                  :id="'textarea-objetos-conhecimento'"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label :id="'label-habilidades'">HABILIDADES</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.habilidades ? plano.habilidades : '- - -'"
                  :id="'textarea-habilidades'"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label :id="'label-indicacoes-metodologicas'">INDICAÇÕES METODOLÓGICAS</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.metodologia ? plano.metodologia : '- - -'"
                  :id="'textarea-indicacoes-metodologicas'"
                ></v-textarea>
              </v-col>
            </v-row>
            <!-- REFERÊNCIA PNLD -->
            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label :id="'label-referencia-pnld'">REFERÊNCIA PNLD</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.referencia_pnld ? plano.referencia_pnld : '- - -'"
                  :id="'textarea-referencia-pnld'"
                ></v-textarea>
              </v-col>
            </v-row>

            <!-- AVALIAÇÕES -->
            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label :id="'label-avaliacoes'">AVALIAÇÕES</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.avaliacoes ? plano.avaliacoes : '- - -'"
                  :id="'textarea-avaliacoes'"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label :id="'label-habilidades-saeb'">HABILIDADES SAEB</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="habilidadesFormatadas"
                  :id="'textarea-habilidades-saeb'"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ModalCarteira :dialog="dialogPdf" :pdf="pdf" @update="fecharModal" />
  </main-template>
</template>

<script>
import ModalCarteira from "@/components/Matriculas/EModalCarteira.vue";

export default {
  components: {
    ModalCarteira,
  },
  data() {
    return {
      dialogPdf: false,
      pdf: null,
      showSnackbar: false,
      plano: {},
      plano_id: null,
      seriesSelecionadas: [],
      habilidadeSelecionadas: [],
      recursosSelecionados: [],
      avaliacoesSelecionadas: [],
      duvidasSelecionadas: [],
    };
  },
  computed: {
    habilidadesFormatadas() {
      if (!this.plano?.habilidadesSaeb?.length) return "- - -";
      return this.plano.habilidadesSaeb.map((h) => `• ${h.descricao}`).join("\n");
    },
  },
  async mounted() {
    this.getId();
    this.listarPlano(this.pageNumber);
  },
  methods: {
    async getId() {
      const { id } = this.$route.params;
      this.plano_id = id;
    },
    async listarPlano() {
      this.$loaderService.open("Carregando Plano");
      try {
        this.plano = await this.$services.planosService.show(this.plano_id);
        // console.log(this.plano);

        this.seriesSelecionadas = (this.plano.gestao_de_aula?.turma?.series ?? []).map(
          (s) => s.descricao
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async visualizarPdf(gestao, etapa_id, disciplina) {
      this.pdf = await this.$services.planosService.visualizarPdfPlanoBimestral(
        parseInt(gestao, 10),
        parseInt(etapa_id, 10),
        parseInt(disciplina, 10)
      );
    },
    fecharModal() {
      this.pdf = null;
      this.dialogPdf = false;
    },
  },
};
</script>

<style></style>
